export default "__VITE_ASSET__Bz$SUYoK__"